import { create } from "zustand"

// "Owner: <name>" for the quotation editor's header (REQ-392), or null when it must not show.
// A store, not a prop, because Apryse renders the header once and it captures its props then.
// `useSyncQuotationOwnerLabel` is the only writer.
type Store = {
	ownerLabel: string | null
	setOwnerLabel: (ownerLabel: string | null) => void
}

export const useQuotationOwnerStore = create<Store>((set) => ({
	ownerLabel: null,
	setOwnerLabel: (ownerLabel) => set({ ownerLabel }),
}))
